module.exports = __webpack_public_path__ + "img/SvenNielsen_140x140_rund.01170898.jpg";